<template>
  <div id="app">
    <transition>
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
	// import store from '@/store'
export default {
  name: 'App',
  provide() {
    return {
    }
  },
  data() {
    return {
    }
  },
  created() {
    
  },
  methods: {

  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.con-box{
	width: 1200px;
	margin: 0 auto;
}
</style>
